if (!customElements.get('netty-product')) {
  customElements.define('netty-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const source = this.querySelector('[data-variants]');
      const select = this.querySelector('[data-variant-select]');
      if (!source || !select) return;
      try { this.variants = JSON.parse(source.textContent); } catch { return; }
      this.initialized = true;
      this.select = select;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      select.addEventListener('change', () => this.choose(select.value, true), options);
      this.querySelectorAll('[data-variant-button]').forEach(button => {
        button.addEventListener('click', () => this.choose(button.dataset.variantButton, true), options);
      });
      this.querySelectorAll('[data-photo-link]').forEach(link => {
        link.addEventListener('click', event => { event.preventDefault(); this.showPhoto(link.dataset.photoLink); }, options);
      });
      window.addEventListener('popstate', () => {
        const id = new URL(location.href).searchParams.get('variant');
        this.choose(id || this.variants[0]?.id, false);
      }, options);
      this.querySelector('[data-native-selector]').hidden = true;
      this.querySelector('[data-color-picker]').hidden = false;
      this.choose(select.value, false);
    }
    disconnectedCallback() { this.controller?.abort(); this.initialized = false; }
    choose(id, updateUrl) {
      const variant = this.variants.find(value => String(value.id) === String(id));
      if (!variant) return;
      this.select.value = String(variant.id);
      this.querySelector('[data-price]').textContent = variant.price;
      this.querySelector('[data-color-name]').textContent = variant.title;
      this.querySelector('[data-sku]').textContent = variant.sku || '—';
      this.querySelectorAll('[data-variant-button]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.variantButton === String(variant.id)));
      });
      const add = this.querySelector('[data-add-button]');
      add.disabled = !variant.available;
      add.textContent = variant.available ? this.dataset.addLabel : this.dataset.unavailableLabel;
      this.querySelector('[data-status]').textContent = variant.available ? this.dataset.availableStatus : this.dataset.unavailableStatus;
      this.querySelector('[data-availability-link]').hidden = variant.available;
      const quantity = this.querySelector('[data-quantity]');
      quantity.min = variant.min || 1;
      quantity.step = variant.step || 1;
      if (variant.max != null) quantity.max = variant.max; else quantity.removeAttribute('max');
      quantity.value = variant.min || 1;
      this.showPhoto(variant.imageId);
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }
    showPhoto(id) {
      const photos = [...this.querySelectorAll('[data-photo]')];
      if (!photos.some(photo => photo.dataset.photo === String(id))) return;
      photos.forEach(photo => { photo.hidden = photo.dataset.photo !== String(id); });
      this.querySelectorAll('[data-photo-link]').forEach(link => link.setAttribute('aria-current', String(link.dataset.photoLink === String(id))));
    }
  });
}
